<template>
    <v-container>
        <v-card>
          <v-card-actions >
            <v-flex class="text-xs-left">
              <h4 class="primary--text">{{resource | capitalize }}  List</h4>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn v-if="allowAdd" color="primary" flat dark @click="addItem"><v-icon dark>add</v-icon>Add {{resource | capitalize}}</v-btn>
            </v-flex>
          </v-card-actions>
          <v-card-text>
            <v-data-table
                :headers="fields"
                :items="items"
                :pagination.sync="paginationObj"
                :total-items="paginationObj.totalItems"
                class="elevation-1"
                rows-per-page-text='lang.common.rows_per_page_text'
              >
              <template v-slot:headers="props">
                <tr>
                  <th v-for="header in fields" :key="header.text" align="left">
                    {{ $t(header.text) }}
                  </th>
                </tr>
              </template>
                <template v-slot:items="props">
                  <td :key="field.id" v-for="field in colFields">
                    <div v-if="field.render">{{ field.render(props.item[field.value]) }}</div>
                    <component v-else-if="field.component" :is="field.component(props.item[field.value]).name" v-bind="field.component(props.item[field.value]).propsData">
                      {{field.component(props.item[field.value]).value}}
                      </component>
                    <div v-else>{{ props.item[field.value] }}</div>
                    
                  </td>
                  <td class="justify-left layout px-0">
                    <v-btn v-if="allowEdit" depressed outline icon fab dark color="primary" small @click="editItem(props.item[primaryKey])">
                    <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn v-if="allowDelete" depressed outline icon fab dark color="pink" small @click="deleteItem(props.item[primaryKey])">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
          </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { router } from '../router';
import { CrudService } from "@/services/crud.service";
import { message } from "@/shared/message";

export default {
  name: 'data-table',
  inheritAttrs: false,
  props: {
    resource: {
      type: String,
      default: () => ""
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    primaryKey: {
      type: String,
      default: () => "id"
    },
    pagination: {
      type: Object,
      default: () =>  ({
          descending: false,
          page: 1,
          rowsPerPage: 10,
          sortBy: "",
          totalItems: 0,
          rowsPerPageItems: [10, 20],
          paging: true
        })
    },
    searchQuery:{
      type: Object,
      default: () =>  ({
          queryRule:"",
          isExcel: false,
          hiddenConditions: [],
          tableFieldList:[]
        })
    },
    allowAdd:{
      type: Boolean,
      default: () => true
    },
    allowEdit:{
      type: Boolean,
      default: () => true
    },
    allowDelete:{
      type: Boolean,
      default: () => true
    }
  },
  data: function(){
    return {
        data: {},
        paginationData: this.pagination
    }
  },
  computed: {
    items: function() {
      //var camelCased = this.resource.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
      return this.data.content;
    },
    paginationObj: {
      get: function () {
        return this.paginationData;
      },
      set: function (value) {
        this.paginationData = value;
        this.getItemList();
      }
    },
    colFields: function() {
        return this.fields.filter(function(f) {
        return f.value != 'action'
     })
    }
  },
  methods: {
    getItemList() {
      return CrudService.of(this.resource).getList(this.paginationData, this.searchQuery).then(data => {
        if(data != undefined) {
          this.data = data,
          this.paginationData.totalItems = data.totalElements;
        }
        return data;
      });
    },
    addItem () {
      router.push(`/${this.resource}/edit`);
    },
    editItem (id) {
      router.push(`/${this.resource}/edit/`+id);
    },
    deleteItem (id) {
      if(confirm('Are you sure?')){
        return CrudService.of(this.resource).deleteItem(id).then(() => {
          message.success(`Delete ${this.resource} Success!`);
          this.getItemList();
        });
      }
    }
  }
}
</script>
